import "volt-core/volt"

require.context("volt-core/media", true)
